import calculateSceneHeight from 'helpers/calculations/calculateSceneHeight'
import calculateDistanceToTarget from 'helpers/calculations/calculateDistanceToTarget'
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import v from 'helpers/validator/validator'
import { CONVENTIONAL } from 'helpers/globals'

/**
 * Calculates the tilt and dependents distance to target, horizontal field
 * of view, ppf, and scene height. Tilt passed in also gets validated.
 * @param {Object} camera - The current camera being updated.
 * @param {String} tilt - The tilt to apply and calculate with.
 * @return {Object} The camera passsed in with updated attributes.
*/

export default function updateTilt(camera, tilt) {
  const { distance, cameraHeight, horizontalAngleOfView, verticalAngleOfView, fovMode, aspectRatio, horizontalResolution } = camera
  const angle = fovMode === CONVENTIONAL ? verticalAngleOfView : horizontalAngleOfView

  const validatedTilt = v.validateRange({
    value: tilt,
    base: -90,
    ceiling: Math.max(90 - angle / 2.0, 0),
    options: {
      key: 'tilt',
      value: parseFloat(tilt) + angle / 2.0,
      distance,
      cameraHeight,
      angle
    }
  }).internal
  const convertedTilt = validatedTilt + angle / 2.0

  const distanceToTarget = calculateDistanceToTarget({ distance, tilt: convertedTilt })
  const horizontalFieldOfView = calculateHorizontalFieldOfView({ distance: distanceToTarget, horizontalAngleOfView })

  return Object.assign({}, camera, {
    tilt: convertedTilt,
    distanceToTarget,
    horizontalFieldOfView,
    ppf: calculatePpf({ horizontalResolution, horizontalFieldOfView }),
    sceneHeight: calculateSceneHeight({ tilt: convertedTilt, distance, cameraHeight }),
    verticalFieldOfView: calculateVerticalFieldOfView({ horizontalFieldOfView, aspectRatio })
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateTilt.js